// Quick-Start layout presets. Each entry defines:
//   id          — unique slug
//   title       — display name
//   description — one-line explanation shown on the card
//   Icon        — React component rendering an SVG preview of the layout
//   config      — partial settings object merged over the current state on apply

import { __ } from "@wordpress/i18n";

function ClassicSliderIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Main image */}
            <rect x="4" y="4" width="72" height="40" rx="3" fill="#e2eaf4" />
            {/* Thumbnail strip — first thumb active */}
            <rect x="4" y="47" width="16" height="9" rx="2" fill="#3b82f6" />
            <rect x="22" y="47" width="16" height="9" rx="2" fill="#dbe4ee" />
            <rect x="40" y="47" width="16" height="9" rx="2" fill="#dbe4ee" />
            <rect x="58" y="47" width="16" height="9" rx="2" fill="#dbe4ee" />
        </svg>
    );
}

function LeftThumbsIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Thumbnail column — first thumb active */}
            <rect x="4" y="4" width="12" height="10" rx="2" fill="#3b82f6" />
            <rect x="4" y="17" width="12" height="10" rx="2" fill="#dbe4ee" />
            <rect x="4" y="30" width="12" height="10" rx="2" fill="#dbe4ee" />
            <rect x="4" y="43" width="12" height="10" rx="2" fill="#dbe4ee" />
            {/* Main image */}
            <rect x="19" y="4" width="57" height="52" rx="3" fill="#e2eaf4" />
        </svg>
    );
}

function RightThumbsIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Main image */}
            <rect x="4" y="4" width="57" height="52" rx="3" fill="#e2eaf4" />
            {/* Thumbnail column — first thumb active */}
            <rect x="64" y="4" width="12" height="10" rx="2" fill="#3b82f6" />
            <rect x="64" y="17" width="12" height="10" rx="2" fill="#dbe4ee" />
            <rect x="64" y="30" width="12" height="10" rx="2" fill="#dbe4ee" />
            <rect x="64" y="43" width="12" height="10" rx="2" fill="#dbe4ee" />
        </svg>
    );
}

function GridThumbsIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Main image */}
            <rect x="4" y="4" width="72" height="31" rx="3" fill="#e2eaf4" />
            {/* Grid row 1 — first thumb active */}
            <rect x="4" y="38" width="22" height="8" rx="2" fill="#3b82f6" />
            <rect x="29" y="38" width="22" height="8" rx="2" fill="#dbe4ee" />
            <rect x="54" y="38" width="22" height="8" rx="2" fill="#dbe4ee" />
            {/* Grid row 2 */}
            <rect x="4" y="49" width="22" height="8" rx="2" fill="#dbe4ee" />
            <rect x="29" y="49" width="22" height="8" rx="2" fill="#dbe4ee" />
            <rect x="54" y="49" width="22" height="8" rx="2" fill="#dbe4ee" />
        </svg>
    );
}

function MinimalSliderIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Full-width main image — no thumbnails */}
            <rect x="4" y="3" width="72" height="44" rx="3" fill="#e2eaf4" />
            {/* Left arrow button */}
            <circle cx="11" cy="25" r="5" fill="white" />
            <polyline
                points="12.5,22 9.5,25 12.5,28"
                stroke="#94a3b8"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Right arrow button */}
            <circle cx="69" cy="25" r="5" fill="white" />
            <polyline
                points="67.5,22 70.5,25 67.5,28"
                stroke="#94a3b8"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Dot pagination — one active elongated pill */}
            <circle cx="26" cy="54" r="1.5" fill="#dbe4ee" />
            <circle cx="31" cy="54" r="1.5" fill="#dbe4ee" />
            <rect
                x="34.5"
                y="52.5"
                width="8"
                height="3"
                rx="1.5"
                fill="#3b82f6"
            />
            <circle cx="46" cy="54" r="1.5" fill="#dbe4ee" />
            <circle cx="51" cy="54" r="1.5" fill="#dbe4ee" />
            <circle cx="56" cy="54" r="1.5" fill="#dbe4ee" />
        </svg>
    );
}

function AnchorNavIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Left vertical dot navigation */}
            <circle cx="9" cy="16" r="2.5" fill="#3b82f6" />
            <circle cx="9" cy="26" r="2.5" fill="#dbe4ee" />
            <circle cx="9" cy="36" r="2.5" fill="#dbe4ee" />
            <circle cx="9" cy="46" r="2.5" fill="#dbe4ee" />
            {/* Stacked images on the right */}
            <rect x="18" y="4" width="58" height="24" rx="3" fill="#e2eaf4" />
            <rect x="18" y="32" width="58" height="24" rx="3" fill="#e2eaf4" />
        </svg>
    );
}

function VerticalScrollIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Left single-column thumbnail strip — first thumb active */}
            <rect x="4" y="4" width="13" height="11" rx="2" fill="#3b82f6" />
            <rect x="4" y="17" width="13" height="11" rx="2" fill="#dbe4ee" />
            <rect x="4" y="30" width="13" height="11" rx="2" fill="#dbe4ee" />
            <rect x="4" y="43" width="13" height="11" rx="2" fill="#dbe4ee" />
            {/* Stacked main images on the right */}
            <rect x="20" y="4" width="56" height="26" rx="3" fill="#e2eaf4" />
            <rect x="20" y="33" width="56" height="24" rx="3" fill="#e2eaf4" />
        </svg>
    );
}

function StickySplitRightIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Left column — scrollable stacked gallery */}
            <rect x="3" y="3" width="15" height="15" rx="2" fill="#e2eaf4" />
            <rect x="3" y="21" width="15" height="15" rx="2" fill="#e2eaf4" />
            <rect x="3" y="39" width="15" height="15" rx="2" fill="#e2eaf4" />
            {/* Middle column — sticky large image */}
            <rect x="21" y="8" width="27" height="27" rx="3" fill="#e2eaf4" />
            {/* Right column — sticky product info */}
            <rect x="52" y="10" width="14" height="2" rx="1" fill="#dde5ee" />
            <rect x="52" y="16" width="22" height="3" rx="1.5" fill="#c8d5e2" />
            <rect x="52" y="23" width="14" height="2" rx="1" fill="#dde5ee" />
            <rect
                x="52"
                y="29"
                width="18"
                height="1.5"
                rx="0.75"
                fill="#dde5ee"
            />
            <rect
                x="52"
                y="33"
                width="15"
                height="1.5"
                rx="0.75"
                fill="#dde5ee"
            />
            <rect x="52" y="42" width="22" height="7" rx="2" fill="#3b82f6" />
        </svg>
    );
}

function SingleColumnGridIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Three full-width stacked images */}
            <rect
                x="11"
                y="4"
                width="58"
                height="24"
                rx="3"
                fill="#3b82f6"
            ></rect>
            <rect
                x="11"
                y="32"
                width="58"
                height="24"
                rx="3"
                fill="#e2eaf4"
            ></rect>
        </svg>
    );
}

function HierarchyGridIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Large featured image on top */}
            <rect x="4" y="4" width="72" height="30" rx="3" fill="#3b82f6" />
            {/* Two equal images below */}
            <rect x="4" y="38" width="34" height="18" rx="2" fill="#e2eaf4" />
            <rect x="42" y="38" width="34" height="18" rx="2" fill="#e2eaf4" />
        </svg>
    );
}

function StickySplitIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Left column — sticky large image */}
            <rect x="3" y="8" width="27" height="27" rx="3" fill="#e2eaf4" />
            {/* Middle column — scrollable stacked gallery */}
            <rect x="33" y="3" width="15" height="15" rx="2" fill="#e2eaf4" />
            <rect x="33" y="21" width="15" height="15" rx="2" fill="#e2eaf4" />
            <rect x="33" y="39" width="15" height="15" rx="2" fill="#e2eaf4" />
            {/* Right column — sticky product info */}
            <rect x="51" y="10" width="16" height="2" rx="1" fill="#dde5ee" />
            <rect x="51" y="16" width="22" height="3" rx="1.5" fill="#c8d5e2" />
            <rect x="51" y="23" width="14" height="2" rx="1" fill="#dde5ee" />
            <rect
                x="51"
                y="29"
                width="18"
                height="1.5"
                rx="0.75"
                fill="#dde5ee"
            />
            <rect
                x="51"
                y="33"
                width="15"
                height="1.5"
                rx="0.75"
                fill="#dde5ee"
            />
            <rect x="51" y="42" width="22" height="7" rx="2" fill="#3b82f6" />
        </svg>
    );
}

function TilesIcon() {
    return (
        <svg
            viewBox="0 0 80 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full"
        >
            {/* Row 1 */}
            <rect x="3" y="3" width="35" height="18" rx="2" fill="#3b82f6" />
            <rect x="42" y="3" width="35" height="18" rx="2" fill="#e2eaf4" />
            {/* Row 2 */}
            <rect x="3" y="24" width="35" height="18" rx="2" fill="#e2eaf4" />
            <rect x="42" y="24" width="35" height="18" rx="2" fill="#e2eaf4" />
            {/* Show More button */}
            <rect x="22" y="46" width="36" height="10" rx="2" fill="none" stroke="#94a3b8" strokeWidth="1" />
            <rect x="28" y="50" width="18" height="2" rx="1" fill="#94a3b8" />
            <polyline points="50,49 52,51 50,53" stroke="#94a3b8" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export const GALLERY_LAYOUTS = [
    {
        id: "classic-slider",
        title: __("Classic Slider", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Horizontal thumbnails below the main image with a smooth slide transition.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: ClassicSliderIcon,
        config: {
            galleryType: "thumbnail",
            thumbnailShow: true,
            thumbnailPosition: "bottom",
            thumbnailLayout: "slider",
            mainImageTransition: "slide",
            mainImagePagination: true,
            mainImagePaginationPosition: "bottom",
        },
    },
    {
        id: "left-thumbnails",
        title: __("Left Thumbnails", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Vertical thumbnail strip on the left side with a clean fade transition.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: LeftThumbsIcon,
        config: {
            galleryType: "thumbnail",
            thumbnailShow: true,
            thumbnailPosition: "left",
            thumbnailLayout: "slider",
            mainImageTransition: "fade",
            thumbnailFitToImage: true,
            mainImagePagination: true,
            mainImagePaginationPosition: "bottom",
        },
    },
    {
        id: "right-thumbnails",
        title: __("Right Thumbnails", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Vertical thumbnail strip on the right side with a clean fade transition.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: RightThumbsIcon,
        config: {
            galleryType: "thumbnail",
            thumbnailShow: true,
            thumbnailPosition: "right",
            thumbnailLayout: "slider",
            mainImageTransition: "fade",
        },
    },
    {
        id: "grid-thumbnails",
        title: __("Grid Thumbnails", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Grid of thumbnails below the main image — great for products with many images.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: GridThumbsIcon,
        config: {
            galleryType: "thumbnail",
            thumbnailShow: true,
            thumbnailPosition: "bottom",
            thumbnailLayout: "grid",
            mainImageTransition: "fade",
            thumbnailFitToImage: true,
        },
    },
    {
        id: "minimal-slider",
        title: __("Minimal Slider", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Full-width image slider with no thumbnails — clean arrows and dot pagination only.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: MinimalSliderIcon,
        config: {
            galleryType: "thumbnail",
            thumbnailShow: false,
        },
    },
    {
        id: "anchor-navigation",
        title: __("Anchor Navigation", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Stacked full-width images with scroll-linked dot navigation.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: AnchorNavIcon,
        premium: true,
        config: {
            galleryType: "anchor",
            thumbnailPosition: "left",
            mainImagePaginationType: "dots",
            mainImagePaginationPosition: "left",
        },
    },
    {
        id: "vertical-scroll",
        title: __("Vertical Scroll", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Stacked full-width images with a grid thumbnail strip for navigation.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: VerticalScrollIcon,
        premium: true,
        config: {
            galleryType: "anchor",
            thumbnailPosition: "left",
            mainImagePaginationType: "dots",
            mainImagePaginationPosition: "left",
            stackedNavigationType: "thumbs",
            thumbnailLayout: "grid",
        },
    },
    {
        id: "hierarchy-grid",
        title: __("Hierarchy Grid", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("One large featured image on top with smaller supporting images in a grid below.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: HierarchyGridIcon,
        premium: true,
        config: {
            galleryType: "hierarchy-grid",
            hierarchyGridColumns: 2,
            hierarchyGridItemAspect: "auto",
        },
    },
    {
        id: "single-column-grid",
        title: __("Single Column", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("All images stacked vertically in a single full-width column.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: SingleColumnGridIcon,
        premium: true,
        config: {
            galleryType: "hierarchy-grid",
            hierarchyGridColumns: 1,
            hierarchyGridItemAspect: "auto",
        },
    },
    {
        id: "sticky-split",
        title: __("Sticky Split", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Two-column layout with a scrollable gallery and a sticky product summary.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: StickySplitIcon,
        premium: true,
        config: {
            galleryType: "sticky-split",
            stickySplitMainSide: "left",
        },
    },
    {
        id: "sticky-split-right",
        title: __("Sticky Split Right", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("Gallery on the left, large sticky image in the centre, and product info pinned on the right.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: StickySplitRightIcon,
        premium: true,
        config: {
            galleryType: "sticky-split",
            stickySplitMainSide: "right",
        },
    },
    {
        id: "tiles",
        title: __("Tiles", "wpbean-product-gallery-slider-for-woocommerce"),
        description: __("All images in an equal-sized grid with a Show More / Show Less button to control how many are visible.", "wpbean-product-gallery-slider-for-woocommerce"),
        Icon: TilesIcon,
        premium: true,
        config: {
            galleryType: "tiles",
            tilesColumns: 2,
            tilesItemAspect: "3/2",
            tilesItemFit: "cover",
            tilesInitialCount: 6,
            tilesShowMoreEnabled: true,
        },
    },
];
